<!--  -->
<template>
  <div>
    <van-nav-bar left-arrow title="客户记录统计" @click-left="$router.go(-1)" />
    <div v-if="customerRecordDtl.length > 0" v-cloak>
      <van-cell-group>
        <van-cell>
          <van-row>
            <van-col span="9">姓名</van-col>
            <van-col span="9">电话</van-col>
            <van-col span="6">座位</van-col>
          </van-row>
        </van-cell>
        <template v-for="(item, index) in customerRecordDtl">
          <van-cell center :key="index">
            <van-row>
              <van-col span="9">{{ item.name }}</van-col>
              <van-col span="9">{{ item.phone }}</van-col>
              <van-col span="6">{{ item.code }}</van-col>
            </van-row>
          </van-cell>
        </template>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customerRecordDtl: []
    };
  },
  created() {
    this.getCustomerRecordDtl();
  },
  methods: {
    //客户记录详情
    getCustomerRecordDtl() {
      this.$axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/customerLog",
        data: {
          store_id: sessionStorage.actShopId,
          phone: this.$route.params.phone,
          type: this.$route.params.type
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            this.customerRecordDtl = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell .van-icon {
  font-size: 20px;
}
/deep/ .van-cell__value {
  color: #323233;
}
[v-cloak] {
  display: none !important;
}
.text {
  text-align: center;
  margin-top: 10%;
  font-size: 30px;
}
.wrap {
  background: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  padding: 10px 16px;
  line-height: 24px;
  border-bottom: 1px solid #eee;
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/CustomerRecordDtl.vue